import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.inventory.actions';

import Item from './MenuItem';

class Menu extends React.Component {
    state = {
        options: [
            {
                primary: 'products_menu',
                icon: undefined,
                link: 'products',
                permits: [20, 59, 67],
            },
            {
                primary: 'manage_local_menu',
                icon: undefined,
                link: 'locals',
                permits: [20, 59, 68],
            },
            {
                primary: 'manage_machines_menu',
                icon: undefined,
                link: 'machines',
                permits: [20, 59, 67],
            },
            {
                primary: 'manage_production_list_menu',
                icon: undefined,
                link: 'forecast',
                permits: [20, 59, 66],
            },
            /*
            {
                primary: 'manage_decrease_menu',
                icon: undefined,
                link: 'decrease',
                permits: [20, 66],
            },*/
            {
                primary: 'manage_list_menu',
                icon: undefined,
                link: 'catalogs',
                permits: [20, 59, 67],
            },
        ],
    };

    handleClose = (id, url, e) => {
        this.props.setInventoryWindow(id);
        this.props.history.push('/xef/' + url);
    };

    render() {
        const { proccess_current_window, info, intl } = this.props;
        const { options } = this.state;
        const data = options
            .sort((a, b) =>
                intl.formatMessage({ id: a.primary }) < intl.formatMessage({ id: b.primary })
                    ? -1
                    : 1,
            )
            .filter(
                (f) =>
                    info &&
                    info.security &&
                    info.security.totalPermits &&
                    info.security.totalPermits.some((p) =>
                        f.permits.some((s) => s.toString() === p.toString()),
                    ),
            );
        return (
            <div className={'margin_top_9 flex_full_column'}>
                {data.map((link, index) => (
                    <Item
                        key={randomstring()}
                        active={proccess_current_window === index}
                        primary={link.primary}
                        onClick={(e) => this.handleClose(index, link.link, e)}
                        icon={link.icon}
                        last={data.length === index + 1}
                    />
                ))}
            </div>
        );
    }
}

Menu.propTypes = {
    history: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

function mapStateToProps(state) {
    return {
        info: state.info,
        proccess_current_window: state.proccess_current_window,
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(withRouter(Menu)));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/Menu.js